import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '@app/common/app-setting';
// import { HttpService } from '../../services/base-services/http.service';

@Injectable()
export class AuthenticationEndpoint {
  http1: HttpClient;
  get getloginUrl() { return AppSettings.API_AUTHORIZATION_ENDPOINT + '/oauth2/token'; }

  constructor(http: HttpClient) {
    this.http1 = http;
  }

  login(username: string, password: string): Observable<Response> {
    const data = 'grant_type=password&username=' + username + '&password=' + password + '&client_id=099153c2625149bc8ecb3e85e03f00221';
    const endpointUrl = `${this.getloginUrl}`;
    return this.http1.post<Response>(endpointUrl, data, {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }
  AddAuthToken(AuthToken: string): any {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + AuthToken);
    const obj = {
      headers: httpHeaders,
    };
    return obj;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/authentication/authentication-endpoints.service.ts